import React from 'react'
import PriceRowMarginText from '../PriceRowMarginText'
import { connect } from 'react-redux'

interface MappedProps {
  showMarginInSpoofMode: boolean
}

interface Props {
  marginValue: number
  type: 'exact' | 'estimate'
}

function FlashHotelMarginText(props: Props & MappedProps) {
  const {
    marginValue,
    showMarginInSpoofMode,
    type,
  } = props

  return <>
    {showMarginInSpoofMode && <PriceRowMarginText
      size="M"
      type={type}
      marginValue={marginValue}
    />}
  </>
}

const mapStateToProps = (state: App.State) => ({
  showMarginInSpoofMode: state.config.showMarginInSpoofMode,
})

export default connect(mapStateToProps)(FlashHotelMarginText)
